<template>
  <el-button :type="typeButton" @click="handleClick" :class="classPrefix"
    ><slot></slot
  ></el-button>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ButtonComponent",
  props: {
    typeButton: {
      type: String,
      default: "primary",
      validator: function(value) {
        return ["primary", "success", "info", "warning", "danger"];
      }
    },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      classPrefix: ""
    };
  },
  methods: {
    ...mapGetters("auth", ["getPrefixRoute"]),
    handleClick() {
      this.$emit("click"); // Emit a custom 'click' event
    }
  },
  mounted() {
    const vm = this;
    vm.classPrefix = vm.getPrefixRoute();
  }
};
</script>

<style scoped>
.el-button.el-button--primary.tembici {
  background-color: #0045dd;
}
.el-button.el-button--success.tembici {
  background-color: #79e76d;
}
.el-button.el-button--info.tembici {
  background-color: #93c3dd;
}
.el-button.el-button--warning.tembici {
  background-color: #ffc864;
}
.el-button.el-button--danger.tembici {
  background-color: #ffcdd2;
}
</style>
